import { Component, Vue } from 'vue-property-decorator'
import formatter from '@/helpers/formatter';

@Component
export default class Form extends Vue {
    
    public loading: boolean = false;
    public valid: boolean = true;
    public labels: any = {};
    public form: any = {};
    public rules: any = {};
    public errors: any = {};

    $refs!: {
        form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
    }
    
    created() {
        for (let key in this.form) {
            if (this.form[key] !== null && typeof this.form[key] === 'object') {
                for (let i in this.form[key]) {
                    let key2 = key + '.' + i
                    this.errors[key2] = []
                    if (!this.labels[key2]) {
                        this.labels[key2] = formatter.titlecase(i)
                    }
                }
            }
            else {
                this.errors[key] = []
                if (!this.labels[key]) {
                    this.labels[key] = formatter.titlecase(key)
                }
            }
        }

        this.rules.required = (field: any) => ((v: any) => !!v || 'The ' + (this.labels && this.labels[field] && this.labels[field].toLowerCase() + ' ') + 'field is required')
    };

    public handleErrors(errors: any): void {
        if (errors) {
            this.setErrors(errors);
        } else {
            this.clearErrors();
        }
    }

    public setErrors(errors: any): void {
        for (let key in this.errors) {
            this.errors[key] = errors[key] || []
        }
    }

    public clearErrors(): void {
        for (let key in this.errors) {
            this.errors[key] = []
        }
    }
}
